module.exports = __webpack_public_path__ + "img/4Y5.0e3da3a8.png";